export enum FilterCategory {
  Price = 'price',
  Rating = 'rating',
}
